/**
 * Translation hook for WooAI Chatbot Pro
 *
 * Provides i18n support and RTL detection for React components.
 * Reads translations from window.wooAIChatConfig or window.wooAiChatbot.
 */
export function useTranslation() {
    const config = window.wooAIChatConfig || window.wooAiChatbot || {};
    /**
     * Translate a key with optional parameter interpolation
     * @param key - Translation key
     * @param params - Optional parameters for interpolation {name} -> value
     */
    const t = (key, params) => {
        let value = config?.translations?.[key] || key;
        if (params) {
            Object.entries(params).forEach(([k, v]) => {
                value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
            });
        }
        return value;
    };
    // Handle both boolean and string 'true'/'1' values for isRTL (wp_localize_script converts true to "1")
    const isRTL = (typeof config?.isRTL === 'string' ? config.isRTL === 'true' || config.isRTL === '1' : config?.isRTL) ?? false;
    const locale = config?.locale ?? 'en_US';
    const direction = isRTL ? 'rtl' : 'ltr';
    return { t, isRTL, locale, direction };
}
export default useTranslation;
